import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type Chat2IconProps = Partial<SVGIconProps>;

const Chat2Icon: FC<Chat2IconProps> = (props) => (
  <SVGIcon viewBox="0 0 17 16" {...props}>
    <path
      d="M13.0841 11.2197L13.3441 13.3263C13.4107 13.8797 12.8174 14.2663 12.3441 13.9797L9.55073 12.3197C9.24406 12.3197 8.94407 12.2997 8.65074 12.2597C9.14407 11.6797 9.4374 10.9463 9.4374 10.153C9.4374 8.25966 7.7974 6.72636 5.77073 6.72636C4.9974 6.72636 4.28407 6.94634 3.69073 7.33301C3.67073 7.16634 3.66406 6.99967 3.66406 6.82633C3.66406 3.793 6.2974 1.33301 9.55073 1.33301C12.8041 1.33301 15.4374 3.793 15.4374 6.82633C15.4374 8.62633 14.5107 10.2197 13.0841 11.2197Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4349 10.1532C9.4349 10.9465 9.14157 11.6799 8.64823 12.2599C7.98823 13.0599 6.94156 13.5732 5.76823 13.5732L4.02823 14.6065C3.7349 14.7865 3.36156 14.5399 3.40156 14.1999L3.56823 12.8866C2.67489 12.2666 2.10156 11.2732 2.10156 10.1532C2.10156 8.97986 2.72823 7.94654 3.68823 7.33321C4.28157 6.94654 4.9949 6.72656 5.76823 6.72656C7.7949 6.72656 9.4349 8.25986 9.4349 10.1532Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGIcon>
);

export default Chat2Icon;
